import React, { useState, useEffect } from 'react';
import { isATCEnabled } from '../utils/isATCEnabled';
import { ProductResultsContext } from './ProductResultsContext';
import { publishSponsoredContent } from '../publisher';

const ProductResults = (props) => {
  const { children = null, data: propData, error, loading, responseLoading } = props; // eslint-disable-line
  const [data, setData] = useState(propData);

  useEffect(() => {
    setData(propData);
  }, [propData]);

  // send sponsored product render rate metrics
  useEffect(() => {
    if (loading || !(data?.searchModel?.products?.length > 0)) {
      return;
    }

    const requestedProducts = data.searchModel.products;
    const renderedProducts = requestedProducts.filter((product) => isATCEnabled(product));
    const requestedSponsoredProducts = requestedProducts.filter((product) => product.info?.isSponsored);
    const renderedSponsoredProducts = renderedProducts.filter((product) => product.info?.isSponsored);

    if (requestedSponsoredProducts.length > 0) {
      publishSponsoredContent(requestedProducts.length,
        renderedProducts.length,
        requestedSponsoredProducts.length,
        renderedSponsoredProducts.length
      );
    }
  }, [data?.searchModel?.products]);

  const resp = {
    data,
    error,
    loading,
    responseLoading,
    setData
  };

  return (
    <ProductResultsContext.Provider value={resp}>
      {children}
    </ProductResultsContext.Provider>
  );
};

export { ProductResults };
